export default "__VITE_ASSET__DHa$MMUm__"